import { ChPopoverAlign } from "@genexus/chameleon-controls-library";

/* The purpose of config is to provide a simple way to change options/settings that are generally applied on all the components*/
export const config = {
  // tooltip is a property that exists on some gemini controls. When set to true, it will display the error/warning/success message (if any) by using a tooltip, instead of displaying the message under the control. The tooltip prevents changes on the component total height, which is desired.
  tooltip: true,
  gxgMessage: {
    common: {
      type: "text-regular",
      textAlign: "center",
      padding: "m",
      maxWidth: "250px",
      minHeight: "300px"
    }
  },
  gxIdeContainer: {
    slimmerFooter: true
  },
  tabularGrid: {
    colSize: {
      minContent: "min-content",
      maxContent: "max-content",
      auto: "auto",
      common: "minmax(100px, 1fr)",
      commonDouble: "minmax(150px, 2fr)",
      description: "minmax(300px, 1fr)",
      serverName: "150px",
      userName: "150px"
    }
  },
  loader: {
    /* The amount of milliseconds the loader will display, before abort because of timeout*/
    timeout: 4000
  },
  tooltipSettings: {
    blockAlign: "outside-start" as ChPopoverAlign,
    inlineAlign: "inside-start" as ChPopoverAlign,
    delay: 200,
    delayLong: 800
  },
  /* The amount of milliseconds for any control that supports debounce */
  inputDebounce: 500,
  headingsClasses: {
    cardRegular: "subtitle-regular-s",
    cardSmall: "body-regular-m"
  },
  utilityClasses: {
    opacityZero: "opacity-0",
    exactMatch: "exact-match"
  }
};

/* - - - - - - - - - - - - - - - - 
ch-tree-view-render
- - - - - - - - - - - - - - - -  */
export const getImagePathTreeViewCallback = (imageSrc: string) =>
  `./assets/icons/${imageSrc}.svg#enabled`;
